'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-273b5552.js');
var React = require('react');
var hooks_useSanitizedUrl = require('./hooks/use-sanitized-url/index.js');
var component = require('./component-21a580e6.js');
var element = require('./element-2d0b0a9a.js');
var styled = require('styled-components');
var elementOutline = require('./element-outline-e92b8ea2.js');
var focusVisibleSelector = require('./focus-visible-selector-7139d43f.js');
var theme = require('./theme-aad7ebc2.js');
var Link = require('./Link-d540ccdb.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2, _templateObject3;

// spacing
var linkIconSpacing = '8px';

// radius
var linkBackgroundRadius = '4px';
var linkFocusRadius = '4px';
var StyledLink = styled__default['default'](Link.Link)(_templateObject || (_templateObject = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  display: flex;\n  place-items: center;\n"])));
var StyledIconLink = styled__default['default'](StyledLink)(_templateObject2 || (_templateObject2 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  cursor: pointer;\n  width: fit-content;\n  padding: 0 ", ";\n  margin: 0 -", ";\n  color: ", ";\n\n  &", " {\n    ", "\n    &::after {\n      top: 0;\n      bottom: 0;\n    }\n  }\n\n  :hover {\n    background-color: ", ";\n    border-radius: ", ";\n    text-decoration: none;\n    position: relative;\n  }\n\n  svg {\n    width: ", ";\n    height: ", ";\n    ", " {\n      width: ", ";\n      height: ", ";\n    }\n    margin-right: ", ";\n    margin-left: ", ";\n\n    path {\n      fill: ", ";\n    }\n  }\n"])), linkFocusRadius, linkFocusRadius, function (props) {
  return props.theme.linkColors.linkFontColor;
}, focusVisibleSelector.focusVisibleSelectorMixin, function (props) {
  return elementOutline.createElementOutlineMixin({
    radius: linkBackgroundRadius,
    width: '2px',
    color: props.theme.linkColors.linkOutlineColor
  });
}, function (props) {
  return props.theme.linkColors.linkHoverBackgroundColor;
}, linkFocusRadius, function (props) {
  return theme.iconLinkSizes[props.size].linkSize;
}, function (props) {
  return theme.iconLinkSizes[props.size].linkSize;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up('lg');
}, function (props) {
  return props.size === 'large' ? '1.5rem' : '';
}, function (props) {
  return props.size === 'large' ? '1.5rem' : '';
}, function (props) {
  return props.iconPlacement === 'left' ? linkIconSpacing : 0;
}, function (props) {
  return props.iconPlacement === 'right' ? linkIconSpacing : 0;
}, function (props) {
  return props.theme.linkColors.linkIconColor;
});
var UnderlineLinkWrapper = styled__default['default'](Link.Link)(_templateObject3 || (_templateObject3 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  color: ", ";\n  cursor: pointer;\n  border-bottom: ", ";\n  &:hover {\n    background-color: ", ";\n    border-radius: ", " ", " 0 0;\n    text-decoration: none;\n  }\n  &", " {\n    ", "\n  }\n  &:focus {\n    outline-style: unset;\n  }\n  &:visited {\n    color: ", ";\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.underlineLinkColors.linkFontColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "1px solid ".concat(theme.underlineLinkColors.linkUnderlineColor);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.underlineLinkColors.linkHoverBackgroundColor;
}, linkFocusRadius, linkFocusRadius, focusVisibleSelector.focusVisibleSelectorMixin, function (_ref5) {
  var theme = _ref5.theme;
  return elementOutline.createElementOutlineMixin({
    color: theme.underlineLinkColors.linkOutlineColor,
    width: '2px',
    inset: '-2px',
    radius: '4px'
  });
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.underlineLinkColors.linkFontColor;
});

var _excluded = ["link", "iconPlacement", "icon", "size", "children"];

/**
 *
 * @param link - The link url. Refers to the href location for this link.
 * @param wrapperRef - (optional) ref element to access <IconLinkWrapper>
 * @param styledLinkRef - (optional) ref element to access <StyledLink>
 * @param themeName - (optional) The theme name. Refers to the background color behind the input. Values supported are 'white', 'light', 'midtone' or 'dark'
 * @param iconPlacement - (optional) Refers to the location of the arrow icon. Values supported are 'left' and 'right'.
 * @param size - (optional) Refers to the size of the icon font and the arrow height. Values supported are 'small', 'default', and 'large'
 */
var IconLink = function IconLink(_ref) {
  var link = _ref.link,
    _ref$iconPlacement = _ref.iconPlacement,
    iconPlacement = _ref$iconPlacement === void 0 ? 'right' : _ref$iconPlacement,
    icon = _ref.icon,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    children = _ref.children,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default['default'].createElement(StyledIconLink, _rollupPluginBabelHelpers._extends({}, props, {
    iconPlacement: iconPlacement,
    size: size,
    href: hooks_useSanitizedUrl.useSanitizedUrl(link),
    underline: "none"
  }), iconPlacement === 'left' ? /*#__PURE__*/React__default['default'].createElement(component.OwnUpIcon, {
    icon: icon
  }) : null, size === 'small' && /*#__PURE__*/React__default['default'].createElement(element.OwnUpSmallBodyMedium, {
    variant: "body2"
  }, children), size === 'large' && /*#__PURE__*/React__default['default'].createElement(element.OwnUpLargeBodyMedium, {
    variant: "body2"
  }, children), size === 'default' && /*#__PURE__*/React__default['default'].createElement(element.OwnUpBodyMedium, {
    variant: "body2"
  }, children), iconPlacement === 'right' ? /*#__PURE__*/React__default['default'].createElement(component.OwnUpIcon, {
    icon: icon
  }) : null);
};

exports.IconLink = IconLink;
exports.UnderlineLinkWrapper = UnderlineLinkWrapper;
//# sourceMappingURL=icon-link-f19c861a.js.map
